<footer class="custom-footer text-white">
    <div class="footer-content">
        <div class="footer-links">
            <a href="/banorte/GFB/Aviso-de-Privacidad-Integral/Terminos-Legales.html"
                class="footer-link">Términos Legales</a>
            <span class="separator">|</span>
            <a href="/banorte/GFB/Aviso-de-Privacidad-Integral.html"
                class="footer-link">Aviso de Privacidad</a>
            <span class="separator">|</span>
            <a href="/banorte/Personal/Costos-y-Comisiones.html"
                class="footer-link">Consulta los costos y comisiones de nuestros productos</a>
        </div>
        <div class="footer-copy">
            {{years}} Grupo Financiero Banorte. Derechos reservados.
        </div>
    </div>
</footer>
<app-modal [url]="url" *ngIf="url"></app-modal>